import '@septima/septima-search/src/css/defaultView.css';
import '@septima/septima-search/lib/jquery.better-autocomplete.js';
import '@septima/septima-search/lib/jquery.caret.1.02.js';
import Controller from '@septima/septima-search/src/js/Controller';
import DefaultView from '@septima/septima-search/src/js/defaultview/DefaultView';
import DawaSearcher from '@septima/septima-search/src/js/searchers/DawaSearcher';
import GeoStednavnSearcher from '@septima/septima-search/src/js/searchers/GeoStednavnSearcher';
// import DawaStednavnSearcher from '@septima/septima-search/src/js/searchers/DawaStednavnSearcher';

export function setupSearch(targetElement, selectHandler, errorHandler, kommunekode) {
  let controller = new Controller(
    [], {
      onError: errorHandler,
      blankBehavior: 'none', // search
    });

  let dawaSearcher = new DawaSearcher({
    kommunekode: kommunekode,
    showOneStreet: false,
    onSelect: selectHandler,
    minimumShowCount: 0,
  });

  controller.addSearcher({
    searcher: dawaSearcher,
  });

  let geoStednavnSearcher = new GeoStednavnSearcher({
    authParams: {
      login: 'septima',
      password: 'fgd4Septima',
    },
    kommunekode: kommunekode,
    stedkat: null,
    onSelect: selectHandler,
  });
  controller.addSearcher({
    searcher: geoStednavnSearcher,
  });

  // let dawaStednavnSearcherOptions = {
  //   types: [{
  //     name: 'Bebyggelse',
  //     hovedtype: 'Bebyggelse|Bygning',
  //   }, {
  //     name: 'Motor og motocrossbane',
  //     undertype: 'motorbane|motocrossbane',
  //     iconuri: 'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMzc5LjgyODEyNSAwaC0yMTcuNjU2MjVjLTcyLjg3NSAwLTEzMi4xNzE4NzUgNTkuMjk2ODc1LTEzMi4xNzE4NzUgMTMyLjE3MTg3NXY3OC44MjgxMjVoLTMwdjMwaDEyMHYtMzBoLTMwdi03OC44MjgxMjVjMC0zOS44MDA3ODEgMzIuMzcxMDk0LTcyLjE3MTg3NSA3Mi4xNzE4NzUtNzIuMTcxODc1aDIxNy42NTYyNWMzOS44MDA3ODEgMCA3Mi4xNzE4NzUgMzIuMzcxMDk0IDcyLjE3MTg3NSA3Mi4xNzE4NzV2NjFjMCAzMS4xMTMyODEtMTkuODM1OTM4IDU4LjYyNS00OS4zNTE1NjIgNjguNDY4NzVsLTYwLjc4OTA2MyAyMC4yNTc4MTNjLTQxLjc3NzM0NCAxMy45NDUzMTItNjkuODU5Mzc1IDUzLjg5NDUzMS02OS44NTkzNzUgOTcuOTI5Njg3IDAgMzkuODAwNzgxLTMzLjM3MTA5NCA3Mi4xNzE4NzUtNzMuMTcxODc1IDcyLjE3MTg3NWgtMzYuNjU2MjVjLTM5LjgwMDc4MSAwLTcyLjE3MTg3NS0zMi4zNzEwOTQtNzIuMTcxODc1LTcyLjE3MTg3NXYtNzguODI4MTI1aDMwdi0zMGgtMTIwdjMwaDMwdjc4LjgyODEyNWMwIDcyLjg3NSA1OS4yOTY4NzUgMTMyLjE3MTg3NSAxMzIuMTcxODc1IDEzMi4xNzE4NzVoMzYuNjU2MjVjNzIuODc1IDAgMTMzLjE3MTg3NS01OS4yOTY4NzUgMTMzLjE3MTg3NS0xMzIuMTcxODc1IDAtMTguMTc5Njg3IDExLjU4NTkzOC0zNS4yNSAyOC44NDM3NS00MS4wMDc4MTNsNjAuNzg5MDYyLTIwLjI2OTUzMWM1NC4wNTQ2ODgtMTguMDE5NTMxIDkwLjM2NzE4OC02OC40MTAxNTYgOTAuMzY3MTg4LTEyNS4zNzg5MDZ2LTYxYzAtNzIuODc1LTU5LjI5Njg3NS0xMzIuMTcxODc1LTEzMi4xNzE4NzUtMTMyLjE3MTg3NXptMCAwIi8+PC9zdmc+'
  //   }],
  //   onSelect: selectHandler,
  // };
  // controller.addSearcher({ searcher: new DawaStednavnSearcher(dawaStednavnSearcherOptions) });

  let view = new DefaultView({
    input: targetElement,
    controller: controller,
    mouseover: true,
    limit: 10,
  });

  return view;
}
